module.exports = __webpack_public_path__ + "images/apple-touch-icon-120x120-8ffd0b98b8cc716b6084dcf71d0a1829.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/apple-touch-icon-120x120.png
// module id = ./src/images/favicons/apple-touch-icon-120x120.png
// module chunks = 1